<template>
    <g fill-rule="evenodd">
        <path d="M20.625 10.875h-7.5v-7.5c0-.207-.168-.375-.375-.375h-1.5c-.207 0-.375.168-.375.375v7.5h-7.5c-.207 0-.375.168-.375.375v1.5c0 .207.168.375.375.375h7.5v7.5c0 .207.168.375.375.375h1.5c.207 0 .375-.168.375-.375v-7.5h7.5c.207 0 .375-.168.375-.375v-1.5c0-.207-.168-.375-.375-.375z" transform="translate(-752 -473) translate(749 470)"/>
    </g>
</template>

<script>
export default {
    name: 'plusIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 18 18');
    }
};
</script>
